import React from 'react';
import { Box, Typography } from '@mui/material';
import { colors } from '../styles/theme';

interface FooterProps {
  sx?: object;
}

const Footer: React.FC<FooterProps> = ({ sx }) => {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: colors.beige,
        py: 3,
        mt: 'auto',
        borderTop: '1px solid rgba(47, 65, 86, 0.1)',
        ...sx,
      }}
    >
      <Typography
        variant="body2"
        align="center"
        sx={{
          color: colors.navy,
          opacity: 0.6,
          fontFamily: '"SF Pro Text", -apple-system, BlinkMacSystemFont, sans-serif',
          fontSize: '0.875rem',
        }}
      >
        © {currentYear} DrSync. Tüm hakları saklıdır.
      </Typography>
    </Box>
  );
};

export default Footer;
